module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "LINESPACE",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "eSANS_Tw_Cen_MT_Medium_11"
  }, [_vm._v("An identity is questioned only when it is menaced, as when the mighty begin to fall, or when the wretched begin to rise, or when the stranger enters the gates, never, thereafter, to be a stranger … Identity would seem to be the garment with which one covers the nakedness of the self: in which case, it is best that the garment be loose, a little like the robes of the desert, through which one’s nakedness can always be felt, and, sometimes, discerned. This trust in one’s nakedness is all that gives one the power to change one’s robes.")])])]), _vm._v(" "), _c('p', {
    staticClass: "EPA"
  }, [_c('span', {
    staticClass: "eSANS_Tw_Cen_MT_Medium_11"
  }, [_vm._v("—James Baldwin,")]), _vm._v(" "), _c('span', {
    staticClass: "eSANS_Tw_Cen_MT_Medium_Italic_I_11"
  }, [_vm._v("The Devil Finds Work: An Essay")]), _c('span', {
    staticClass: "eSANS_Tw_Cen_MT_Medium_11"
  }, [_vm._v(", 1976")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0